export default __webpack_public_path__ + "static/media/coin-stats.b1a638d4.png";